/**
 * Copyright Mántum All Rights Reserved.
 */
import fetch from './network/fetch';
import file from './network/file';
import get from './network/get';
import observable from './network/observable';
import post from './network/post';
import put from './network/put';
import remove from './network/remove';

export default {
    delete: remove,
    fetch,
    file,
    get,
    observable,
    post,
    put
};
